import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "@/lib/analytics";

/**
 * Fire a GA4 `page_view` on every SPA route change. Must be rendered inside
 * the `<BrowserRouter>` subtree so `useLocation` is available.
 */
export function useRouteTracking(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}
